<template>
  <VirtualAccountContainer>
    <Title>가상계좌발송</Title>
    <NoticeSection>
      <div>* 가상계좌등록 5분 이내에 입금안내 문자가 자동발송됩니다.</div>
      <div>* 기존고객은 '내역불러오기'로 동일한 가상계좌를 사용할 수 있습니다.</div>
    </NoticeSection>
    <HistoryTable>
      <tbody>
        <tr>
          <Th>
            <RedSpan>*</RedSpan>고객명
          </Th>
          <Td>
            <InputContainer>
              <Input type="text" v-model="cusnm" placeholder="신규고객명" :class="{ 'error': errors.cusnm }" />
              <CustomerHistoryButton @click="getcusnm">
                내역불러오기
              </CustomerHistoryButton>
            </InputContainer>
            <ErrorMessage v-if="errors.cusnm">{{ errors.cusnm }}</ErrorMessage>
          </Td>
        </tr>
        <tr>
          <Th>
            <RedSpan>*</RedSpan>연락처
          </Th>
          <Td>
            <div class="input-container">
              <Input type="text" placeholder="연락처 입력" v-model="mobile" :class="{ 'error': errors.mobile }"
                @input="handleMobileInput" />
              <ErrorMessage v-if="errors.mobile">{{ errors.mobile }}</ErrorMessage>
              <MobileCheckMessage v-if="mobileCheckMessage.show">
                <span v-html="mobileCheckMessage.text"></span>
              </MobileCheckMessage>
            </div>
          </Td>
        </tr>
        <tr>
          <Th>가상계좌번호</Th>
          <Td>
            <Input type="text" placeholder="가상계좌번호" v-model="vano" readonly
              style="background-color: #f5f5f5; text-align: center;" />
          </Td>
        </tr>
        <tr>
          <Th>가상계좌은행</Th>
          <Td>농협</Td>
        </tr>
        <tr>
          <Th>
            <RedSpan>*</RedSpan>입금가능기간
          </Th>
          <Td>
            <DatePicker v-model:value="edate" placeholder="입금가능기간" style="width: 90%;" />
          </Td>
        </tr>
        <tr>
          <Th>
            <RedSpan>*</RedSpan>항목명
          </Th>
          <Td>
            <Select v-model="payitemnm" :class="{ 'error': errors.payitemnm }">
              <option value="">선택</option>
              <option value="본인부담금">본인부담금</option>
              <option value="비급여">비급여</option>
              <option value="기타">기타</option>
            </Select>
            <ErrorMessage v-if="errors.payitemnm">{{ errors.payitemnm }}</ErrorMessage>
          </Td>
        </tr>
        <tr>
          <Th>
            <RedSpan>*</RedSpan>입금금액
          </Th>
          <Td>
            <Input type="number" v-model="payamt" min="500" :class="{ 'error': errors.payamt }" />
            <ErrorMessage v-if="errors.payamt">{{ errors.payamt }}</ErrorMessage>
          </Td>
        </tr>
        <tr>
          <Th>현금영수증번호</Th>
          <Td>
            <Input type="text" placeholder="개발중입니다." v-model="payreceiptno" style="background-color: #f5f5f5;"
              readonly />
          </Td>
        </tr>
        <tr>
          <Th>비고</Th>
          <Td>
            <TextArea placeholder="비고를 입력하세요" v-model="remark" />
          </Td>
        </tr>
      </tbody>
    </HistoryTable>

    <ButtonGroup>
      <SubmitButton @click="handleSubmit">등록</SubmitButton>
      <CancelButton @click="$emit('close')">취소</CancelButton>
    </ButtonGroup>
  </VirtualAccountContainer>
</template>

<script>
import * as AccountSendModalCss from '@/assets/styles/account/AccountSendModalCss.js';
import DatePicker from 'vue-datepicker-next';

export default {
  name: 'AccountSendModal',

  emits: ['close', 'success'],

  components: {
    ...AccountSendModalCss,
    DatePicker
  },

  props: {
    customerName: {
      type: String,
      required: false,
      default: ''
    },
    customerPhone: {
      type: String,
      required: false,
      default: ''
    }
  },

  data() {
    return {
      cusnm: '', // 고객명
      mobile: '', // 연락처
      vano: '신규생성', // 가상계좌번호 (내역불러오기 시 값 변경됨)
      edate: new Date(2099, 11, 31), // 입금가능기간
      payitemnm: '', // 항목명
      payamt: '', // 입금금액
      payreceiptno: '', // 현금영수증번호 (향후 업데이트)
      remark: '', // 비고

      // 가상계좌
      virtualSearch: "",
      virtualAccountObj: {
        success_amt: 0,
        danger_amt: 0,
        error_amt: 0,
        data: []
      },

      // 에러 메세지지
      errors: {
        cusnm: '',
        mobile: '',
        payitemnm: '',
        payamt: ''
      },

      mobileCheckMessage: {
        show: false,
        text: '',
      }
    };
  },

  methods: {
    getcusnm() {
      const styleElement = document.createElement('style');
      styleElement.textContent = `
        .swal2-container .customer-table tr {
          cursor: pointer;
        }
        .swal2-container .customer-table tr:hover {
          background-color: #ffeccc !important;
        }
      `;
      document.head.appendChild(styleElement);

      this.$swal.fire({
        title: '가상계좌 고객 불러오기',
        width: '1000px',
        html: `
          <div style="margin-bottom: 20px;">
            <input type="text" 
              id="searchCustomer" 
              placeholder="고객명 또는 연락처 검색" 
              style="width:98%; padding:8px; margin-bottom:10px;" 
            />
            <div id="customerList" style="max-height:500px; overflow-y:auto;"></div>
          </div>
        `,
        showConfirmButton: false,
        showCloseButton: true,
        didOpen: () => {
          const searchInput = document.getElementById('searchCustomer');
          if (searchInput) {
            searchInput.value = '';
            searchInput.focus();
            searchInput.addEventListener('keyup', (e) => {
              if (e.key === 'Enter') {
                this.search_customer(searchInput.value);
              }
            });
            this.search_customer('');
          }
        },
        willClose: () => {
          // 모달이 닫힐 때 스타일 요소 제거
          document.head.removeChild(styleElement);
        }
      });
    },
    async table_search() {
      const search_data = this.virtualSearch;
      await this.row_init(search_data);
      this.getacc().then(response => {
        if (response.data.code === 200) {
          this.availableAccount = response.data.data.notuse_cnt;
          this.usedAccount = response.data.data.use_cnt;
        }
      });
    },
    async getlist(search_data) {
      try {
        const response = await this.$axios.post(
          `${this.$apiUrls.virtualaccount}/virtualaccount/getlist`,
          { search: search_data }
        );
        return response;
      } catch (error) {
        console.error('고객 목록 조회 오류:', error);
        throw error;
      }
    },
    async getacc() {
      const response = await this.$axios.post(`${this.$apiUrls.virtualaccount}/virtualaccount/getacc`, {
        thebill_id: this.$globalState.thebill_id
      });
      this.virtualAccountObj.use_list = response.data.data.use_list;
      this.virtualAccountObj.notuse_list = response.data.data.notuse_list;
      return response;
    },
    async row_init(search_data) {
      try {
        const response = await this.getlist(search_data);
        console.log(response);

        // 초기화
        this.virtualAccountObj = {
          success_amt: 0,
          danger_amt: 0,
          error_amt: 0,
          data: []
        };

        if (response.data.code === 200) {
          this.virtualAccountObj.data = response.data.data;

          // 각 아이템에 대해 결과 메시지 계산
          this.virtualAccountObj.data.forEach(item => {
            let result_msg = '';
            if (item.RESULTCD == null) {
              result_msg = '등록대기';
            } else if (item.RESULTCD != "D000") {
              result_msg = `등록실패[${item.RESULTCD}]<br/>${item.RESULTMSG}`;
              this.virtualAccountObj.error_amt += parseInt(item.PAYITEMAMT);
            } else {
              result_msg = '미납';
              if (item.REGDT !== null) {
                this.virtualAccountObj.success_amt += parseInt(item.PAYITEMAMT);
                result_msg = `납부<br/> ${item.PAYDAY.replace(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1-$2-$3 $4:$5:$6')}`;
              } else {
                this.virtualAccountObj.danger_amt += parseInt(item.PAYITEMAMT);
              }
            }
            item.result_msg = result_msg;
          });
        } else {
          this.virtualAccountObj.data = [];
        }
      } catch (error) {
        console.error('데이터 초기화 오류:', error);
      }
    },

    // ---------------------- 내역불러오기 ----------------------
    async search_customer(search) {
      try {
        const response = await this.$axios.post(
          `${this.$apiUrls.virtualaccount}/virtualaccount/search_customer`,
          { search: search }
        );

        if (response.data.code === 200) {
          this.updateCustomerList(response.data.data);
        }
      } catch (error) {
        console.error('고객 검색 에러:', error);
        const customerList = document.getElementById('customerList');
        if (customerList) {
          customerList.innerHTML = '<p style="color: red;">검색 중 오류가 발생했습니다.</p>';
        }
      }
    },

    updateCustomerList(results) {
      const customerList = document.getElementById('customerList');
      if (!customerList) return;

      let htmlContent = '';
      if (!results || results.length === 0) {
        htmlContent = `<div style="text-align:center; padding:8px;">검색결과가 없습니다.</div>`;
      } else {
        htmlContent = `
          <table class="customer-table" style="width:100%; border-collapse:collapse;">
            <thead>
              <tr>
                <th style="padding:12px 8px; border:1px solid #ddd; background-color:#fb8b24; color: black">최초등록일</th>
                <th style="padding:12px 8px; border:1px solid #ddd; background-color:#fb8b24; color: black">고객명</th>
                <th style="padding:12px 8px; border:1px solid #ddd; background-color:#fb8b24; color: black">연락처</th>
                <th style="padding:12px 8px; border:1px solid #ddd; background-color:#fb8b24; color: black">가상계좌번호</th>
                <th style="padding:12px 8px; border:1px solid #ddd; background-color:#fb8b24; color: black">비고</th>
              </tr>
            </thead>
            <tbody>
              ${results.map(item => `
                <tr style="cursor:pointer;" onclick='document.dispatchEvent(new CustomEvent("select-customer", { detail: ${JSON.stringify(item)} }))'>
                  <td style="padding:12px 8px; border:1px solid #ddd;">${item.PAYMASDT || ''}</td>
                  <td style="padding:12px 8px; border:1px solid #ddd;">${item.CUSNM || ''}</td>
                  <td style="padding:12px 8px; border:1px solid #ddd;">${item.MOBILENO || ''}</td>
                  <td style="padding:12px 8px; border:1px solid #ddd;">${item.VANO || ''}</td>
                  <td style="padding:12px 8px; border:1px solid #ddd;">${item.txt || ''}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        `;
      }
      customerList.innerHTML = htmlContent;
    },

    select_customer(customer) {
      this.cusnm = customer.CUSNM;
      this.mobile = customer.MOBILENO;
      this.vano = customer.VANO;
      this.clearMobileCheckMessage();
      this.$swal.close();
    },

    // ---------------------- 전화번호 체크 ----------------------
    handleMobileInput() {
      if (this.mobile.trim()) {
        this.mobile_check(this.mobile);
      } else {
        this.clearMobileCheckMessage();
      }
    },

    clearMobileCheckMessage() {
      this.mobileCheckMessage = {
        show: false,
        text: '',
      };
    },

    async mobile_check(data) {
      try {
        const response = await this.$axios.post(
          `${this.$apiUrls.virtualaccount}/virtualaccount/mobile_check`,
          { mobile: data }
        );

        if (response.data.code === 200) {
          if (response.data.data.length !== 0) {
            this.mobileCheckMessage = {
              show: true,
              type: 'warning',
              text: `계좌발급내역이 있는 연락처입니다.<br/>
                    '내역불러오기' 버튼을 눌러 기존계좌<br/> 
                    사용가능합니다.`
            };
          } else {
            this.clearMobileCheckMessage();
          }
        } else if (response.data.code === 400) {
          this.clearMobileCheckMessage();
        } else {
          this.mobileCheckMessage = {
            show: true,
            type: 'error',
            text: '서버오류가 발생했습니다.'
          };
        }
      } catch (error) {
        console.error('연락처 확인 중 오류:', error);
        this.mobileCheckMessage = {
          show: true,
          type: 'error',
          text: '서버오류가 발생했습니다.'
        };
      }
    },

    // ---------------------- 가상계좌 등록 ----------------------
    handleSubmit() {
      if (!this.validateForm()) {
        this.$swal.fire({
          icon: 'warning',
          title: '입력 확인',
          text: '필수 항목을 모두 입력해주세요.',
          confirmButtonColor: '#2563eb'
        });
        return;
      }

      const payload = {
        cusnm: this.cusnm,
        mobile: this.mobile,
        vano: this.vano,
        payitemnm: this.payitemnm,
        payamt: this.payamt,
        payreceiptno: this.payreceiptno,
        remark: this.remark,
        edate: this.edate,
        thebill_id: '30055018'
      };

      this.$axios
        .post(`${this.$apiUrls.virtualaccount}/virtualaccount/create`, payload)
        .then((response) => {
          if (response.data.code === 200) {
            this.$swal.fire({
              icon: 'success',
              title: '완료',
              text: '가상계좌발송이 완료되었습니다.',
              confirmButtonColor: '#2563eb'
            }).then(() => {
              // 부모 컴포넌트에 성공 이벤트 전달
              this.$emit('success');
              this.$emit('close');
            });
          } else {
            this.$swal.fire({
              icon: 'error',
              title: '오류',
              text: response.data.message || '가상계좌발송에 실패했습니다.',
              confirmButtonColor: '#2563eb'
            });
          }
        })
        .catch((error) => {
          console.error('가상계좌발송 오류:', error);
          this.$swal.fire({
            icon: 'error',
            title: '오류',
            text: '서버오류가 발생했습니다.',
            confirmButtonColor: '#2563eb'
          });
        });
    },

    validateForm() {
      this.errors = {
        cusnm: '',
        mobile: '',
        payitemnm: '',
        payamt: ''
      };

      let isValid = true;

      if (!this.cusnm.trim()) {
        this.errors.cusnm = '고객명을 입력해주세요.';
        isValid = false;
      }

      if (!this.mobile.trim()) {
        this.errors.mobile = '연락처를 입력해주세요.';
        isValid = false;
      }

      if (!this.payitemnm.trim()) {
        this.errors.payitemnm = '항목명을 선택해주세요.';
        isValid = false;
      }

      if (!this.payamt || Number(this.payamt) < 500) {
        this.errors.payamt = '입금금액은 최소 500원 이상이어야 합니다.';
        isValid = false;
      }

      return isValid;
    },
  },

  mounted() {
    this.cusnm = this.customerName;
    this.mobile = this.customerPhone;

    this._customerSelectHandler = (e) => {
      this.select_customer(e.detail);
    };
    document.addEventListener('select-customer', this._customerSelectHandler);
  },

  beforeUnmount() {
    document.removeEventListener('select-customer', this._customerSelectHandler);
    this.clearMobileCheckMessage();
  },

  watch: {
    customerName(newVal) {
      this.cusnm = newVal;
    },
    customerPhone(newVal) {
      this.mobile = newVal;
      if (newVal) {
        this.handleMobileInput();
      }
    }
  },
};
</script>